import { createApiReducer } from 'reacticoon/reducer'
import { fetchUserMe } from './actions'

const userMeReducer = createApiReducer(fetchUserMe, { resetDataOnRequest: false })

export default userMeReducer
